import { NumberInput } from "@chakra-ui/react";

interface Props {
  value: number;
  setValue: (value: number) => void;
}

export const DollarInput = ({ value, setValue }: Props) => {
  return (
    <NumberInput.Root
      value={value}
      onValueChange={(details: any) => {
        // If details.valueAsNumber exists, use it; otherwise parse details.value
        if (typeof details.valueAsNumber === "number") {
          setValue(details.valueAsNumber);
        } else {
          const num = parseFloat(details.value);
          if (!isNaN(num)) {
            setValue(num);
          }
        }
      }}
    >
      <NumberInput.Control />
      <NumberInput.Input />
    </NumberInput.Root>
  );
};